import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IClientAllocationActions, IThunkValidateDateRange } from '../types';

const onValidateDateRange: IThunkValidateDateRange = thunk(
  async (
    { setTeamMemberDateValidation }: Actions<IClientAllocationActions>,
    { clinicId, teamId, payload },
  ) => {
    const response = await api.clientAllocation.validateDateRange({ clinicId, teamId }, payload);
    setTeamMemberDateValidation(response.data);
  },
);

export default onValidateDateRange;
